var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutBaguette",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-baguette","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M42.1 0v250h164.6V0H42.1zm128.1 32.6H79.4L57.2 9h134.6l-21.6 23.6zm-4.2 9V209H81.9V41.6H166zm-93.1-2.7v171.5L51.1 234V15.6l21.8 23.3zM78.1 218h90.5l22.7 23H56.9l21.2-23zm96.9-6.3V40.6L197.6 16v218.5L175 211.7z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-baguette.svg